import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PushBounce = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M13.6875 14.8125V18.3885C13.6875 18.6576 13.6345 18.9241 13.5315 19.1728C13.4284 19.4214 13.2774 19.6473 13.0871 19.8376C12.8967 20.0279 12.6708 20.1788 12.4221 20.2817C12.1734 20.3847 11.9069 20.4376 11.6378 20.4375H6.73725C6.46811 20.4376 6.20158 20.3847 5.9529 20.2817C5.70422 20.1788 5.47825 20.0279 5.2879 19.8376C5.09756 19.6473 4.94656 19.4214 4.84354 19.1728C4.74052 18.9241 4.6875 18.6576 4.6875 18.3885V6.73725C4.6875 6.19362 4.90346 5.67226 5.28786 5.28786C5.67226 4.90346 6.19362 4.6875 6.73725 4.6875H11.6378"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6875 17.0625H13.6875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 7C9.86783 7.30466 12.0579 8.19937 12.3902 9.55078"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M15 8.8999C14.3987 9.49754 13.4675 10.7431 13.6582 12.2465"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <circle
      cx="17"
      cy="6.3999"
      r="1.35"
      fill="white"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
    />
  </SvgIcon>
);
